import React from "react";
import { Map } from "immutable";
import classnames from "classnames";
import "./Airline.css";

const Airline = ({ airline = Map() }) => (
  <div
    className={classnames({
      "airline-logo": true,
      airline: true,
      // 'col-wrapper-va' : true,
      // Add IATA code (uppercase) as classname
      [airline.getIn(["industryIdentifier", "identifier"])]: true
    })}
    style={{
      textAlign: "center",
      width: "100%",
      height: "90%",
      whiteSpace: "nowrap",
      fontSize: 0,
      backgroundImage: `url(${process.env.PUBLIC_URL}/images/carrier-logos-svg/${airline.getIn(["industryIdentifier", "identifier"])}.svg)`
    }}
  >
    <span className="v-align">
      {/* <label>{airline.get('name')}</label> */}
      {/* {airline.get('name')} */}
    </span>
  </div>
);

export default Airline;



// WEBPACK FOOTER //
// ./src/ndc/offer/Airline.js